import React from "react";
import { Route, Routes, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { TaskProvider } from "./context/TaskContext";
import { OrderProvider } from "./context/OrderContext";
import Login from "./screens/login/Login";
import Dashboard from "./screens/dashboard/Dashboard";
import OrderPage from "./screens/order/Order";
import Inventory from "./screens/Inventory/Inventory";
import Hitch from "./screens/hitch/Hitch";
import ChangeUsersPassword from "./screens/ChangeUsersPassword/changeUsersPassword";
import UserManagement from "./screens/UserManagement/UserManagement";
import { InventoryProvider } from "./context/InventoryContext";
import { HitchProvider } from "./context/HitchContext";
import { TimeCardProvider } from "./context/TimeCardContext";
import { OverviewProvider } from './context/OverviewContext';
import { AppointmentProvider } from './context/AppointmentContext';

// Roles allowed into the admin Dashboard — website clients are not
const DASHBOARD_ROLES = ["admin", "staff"];

const ProtectedRoute = ({ element: Component, ...rest }) => {
  const { user, loading } = useAuth();
  if (loading) {
    return <p>Loading...</p>;
  }
  // Clients and unknown roles are sent back to login
  if (!user || !DASHBOARD_ROLES.includes(user.role)) {
    return <Navigate to="/login" replace />;
  }
  return <Component {...rest} />;
};

function App() {
  return (
    <AuthProvider>
      <TaskProvider>
        <InventoryProvider>
          <HitchProvider>
            <OrderProvider>
              <TimeCardProvider>
                <OverviewProvider>
                  <AppointmentProvider>
                  <Routes>
                    <Route path="/login" element={<Login />} />
                    <Route
                      path="/"
                      element={<ProtectedRoute element={Dashboard} />}
                    />
                    <Route
                      path="/orders"
                      element={<ProtectedRoute element={OrderPage} />}
                    />
                    <Route
                      path="/inventory"
                      element={<ProtectedRoute element={Inventory} />}
                    />
                    <Route
                      path="/hitch"
                      element={<ProtectedRoute element={Hitch} />}
                    />
                    <Route
                      path="/change-password"
                      element={<ProtectedRoute element={ChangeUsersPassword} />}
                    />
                    <Route
                      path="/user-management"
                      element={<ProtectedRoute element={UserManagement} />}
                    />
                    <Route path="*" element={<Navigate to="/" replace />} />
                  </Routes>
                  </AppointmentProvider>
                </OverviewProvider>
              </TimeCardProvider>
            </OrderProvider>
          </HitchProvider>
        </InventoryProvider>
      </TaskProvider>
    </AuthProvider>
  );
}

export default App;
